import React from 'react'
import { Icon } from './PhoneRingingIcon.elements'

type Props = {
  className?: string
}

export const PhoneRingingIcon = ({ className }: Props) => (
  <Icon
    viewBox="0 0 34 34"
    aria-hidden
    focusable={false}
    role="img"
    className={className}
    fill="none"
  >
    <path d="M27.126 22.839v3.21a2.134 2.134 0 01-.694 1.587 2.145 2.145 0 01-1.643.554 21.248 21.248 0 01-9.255-3.286A20.892 20.892 0 019.1 18.482a21.155 21.155 0 01-3.292-9.28 2.137 2.137 0 011.269-2.15c.272-.12.567-.182.865-.183h3.217a2.147 2.147 0 012.144 1.841c.136 1.028.388 2.037.751 3.008a2.137 2.137 0 01-.482 2.258l-1.362 1.36a17.142 17.142 0 006.434 6.421l1.362-1.359a2.145 2.145 0 012.263-.481c.973.362 1.983.613 3.013.749a2.146 2.146 0 011.844 2.173zM19.674 10.08a5.365 5.365 0 012.765 1.469 5.348 5.348 0 011.47 2.759m-4.235-8.51a9.659 9.659 0 015.755 2.76 9.625 9.625 0 012.77 5.74" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
  </Icon>
)
